import React, { useEffect, useRef } from 'react';
import { FaAws, FaGithub, FaLinux, FaPython } from 'react-icons/fa';
import { SiGo, SiKubernetes, SiTerraform } from 'react-icons/si';
import { VscAzure } from 'react-icons/vsc';

function Skills() {
  const sectionRef = useRef(null);

  const technologies = [
    { icon: <FaAws />, name: 'AWS' },
    { icon: <VscAzure />, name: 'Azure' },
    { icon: <FaPython />, name: 'Python' },
    { icon: <SiGo />, name: 'Go' },
    { icon: <SiKubernetes />, name: 'Kubernetes' },
    { icon: <SiTerraform />, name: 'Terraform' },
    { icon: <FaGithub />, name: 'GitHub' },
    { icon: <FaLinux />, name: 'Linux' },
  ];

  useEffect(() => {
    if (!sectionRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('skill-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const items = sectionRef.current.querySelectorAll('.skill-item');
    items.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  return (
    <section className='skills-section' ref={sectionRef}>
      <h2 className='skills-heading'>Tech Stack</h2>
      <div className='skills-grid'>
        {technologies.map((tech, index) => (
          <div key={index} className='skill-item' style={{ animationDelay: `${index * 0.08}s` }}>
            <div className='skill-icon'>{tech.icon}</div>
            <span className='skill-name'>{tech.name}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Skills;
